module.exports = __webpack_public_path__ + "static/media/glasses-icon-desktop.fa5f3b01.svg";